module.exports = __webpack_public_path__ + "static/media/1.43ec668a.jpg";